if (!customElements.get("recipient-form")) {
	customElements.define(
		"recipient-form",
		class RecipientForm extends HTMLElement {
			constructor() {
				super();
				this.recipientFieldsLiveRegion = this.querySelector(
					`#Recipient-fields-live-region-${this.dataset.sectionId}`
				);
				this.recipientFieldFormRegion = this.querySelector(`#giftcardFormBody`);
				this.checkboxInput = this.querySelector(
					`#Recipient-checkbox-${this.dataset.sectionId}`
				);
				this.checkboxInput.disabled = false;
				this.hiddenControlField = this.querySelector(
					`#Recipient-control-${this.dataset.sectionId}`
				);
				this.hiddenControlField.disabled = true;
				this.emailInput = this.querySelector(
					`#Recipient-email-${this.dataset.sectionId}`
				);
				this.nameInput = this.querySelector(
					`#Recipient-name-${this.dataset.sectionId}`
				);
				this.messageInput = this.querySelector(
					`#Recipient-message-${this.dataset.sectionId}`
				);
				this.sendonInput = this.querySelector(
					`#Recipient-send-on-${this.dataset.sectionId}`
				);
				this.offsetProperty = this.querySelector(
					`#Recipient-timezone-offset-${this.dataset.sectionId}`
				);
				this.sendOnError = this.querySelector("#sendOnError");
				if (this.offsetProperty)
					this.offsetProperty.value = new Date().getTimezoneOffset().toString();

				this.errorMessageWrapper = this.querySelector(
					".product-form__recipient-error-message-wrapper"
				);
				this.errorMessageList = this.errorMessageWrapper?.querySelector("ul");
				this.errorMessage =
					this.errorMessageWrapper?.querySelector(".error-message");
				this.defaultErrorHeader = this.errorMessage?.innerText;
				this.currentProductVariantId = this.dataset.productVariantId;

				this.checkboxInput.addEventListener("change", this.onChange.bind(this));

				if (this.emailInput) {
					this.emailInput.addEventListener("input", () =>
						this.updateAddToCartButtonState()
					);
				}

				if (this.sendonInput) {
					this.sendonInput.addEventListener("input", () =>
						this.updateAddToCartButtonState()
					);
				}

				this.onChange();
			}

			validateSendOnDate() {
				const sendOnDate = this.sendonInput.value;
				const isValid = this.isSendOnDateValid(sendOnDate);

				if (!isValid) {
					// Optionally, add logic to show an error message
				}

				// Update the add to cart button state
				this.updateAddToCartButtonState();
			}

			isSendOnDateValid(dateString) {
				if (!dateString.trim()) {
					// If the date string is empty, consider it as valid
					return true;
				}

				const sendOnDate = new Date(dateString);
				const today = new Date();
				today.setHours(0, 0, 0, 0);

				const maxDate = new Date(today);
				maxDate.setDate(today.getDate() + 59); // 59 days from today

				// Check if sendOnDate is today or in the future, but not more than 59 days from today
				return sendOnDate >= today && sendOnDate <= maxDate;
			}

			cartUpdateUnsubscriber = undefined;
			variantChangeUnsubscriber = undefined;
			cartErrorUnsubscriber = undefined;

			connectedCallback() {
				this.cartUpdateUnsubscriber = subscribe(
					PUB_SUB_EVENTS.cartUpdate,
					(event) => {
						if (
							event.source === "product-form" &&
							event.productVariantId.toString() === this.currentProductVariantId
						) {
							this.resetRecipientForm();
						}
					}
				);

				this.variantChangeUnsubscriber = subscribe(
					PUB_SUB_EVENTS.variantChange,
					(event) => {
						if (event.data.sectionId === this.dataset.sectionId) {
							this.currentProductVariantId = event.data.variant.id.toString();
						}
					}
				);

				this.cartUpdateUnsubscriber = subscribe(
					PUB_SUB_EVENTS.cartError,
					(event) => {
						if (
							event.source === "product-form" &&
							event.productVariantId.toString() === this.currentProductVariantId
						) {
							this.displayErrorMessage(event.message, event.errors);
						}
					}
				);
			}

			disconnectedCallback() {
				if (this.cartUpdateUnsubscriber) {
					this.cartUpdateUnsubscriber();
				}

				if (this.variantChangeUnsubscriber) {
					this.variantChangeUnsubscriber();
				}

				if (this.cartErrorUnsubscriber) {
					this.cartErrorUnsubscriber();
				}
			}

			onChange() {
				if (this.checkboxInput.checked) {
					this.enableInputFields();
					this.recipientFieldFormRegion.classList.remove("hidden");
				} else {
					this.clearInputFields();
					this.disableInputFields();
					this.clearErrorMessage();
					this.recipientFieldFormRegion.classList.add("hidden");
				}

				this.updateAddToCartButtonState();
			}

			updateAddToCartButtonState() {
				const addToCartButton = document.querySelector(
					`button[id^="AddToCart-"]`
				);
				const isEmailBlank =
					this.emailInput && this.emailInput.value.trim() === "";
				const isSendOnDateValid =
					this.sendonInput && this.isSendOnDateValid(this.sendonInput.value);

				const shouldDisableButton =
					this.checkboxInput.checked && (isEmailBlank || !isSendOnDateValid);
				addToCartButton.disabled = shouldDisableButton;

				// Show or hide the error message based on the validity of the send-on date
				if (this.sendonInput && !isSendOnDateValid) {
					this.sendOnError.classList.remove("hidden");
				} else {
					this.sendOnError.classList.add("hidden");
				}
			}

			inputFields() {
				return [
					this.emailInput,
					this.nameInput,
					this.messageInput,
					this.sendonInput,
				];
			}

			disableableFields() {
				return [...this.inputFields(), this.offsetProperty];
			}

			clearInputFields() {
				this.inputFields().forEach((field) => (field.value = ""));
			}

			enableInputFields() {
				this.disableableFields().forEach((field) => (field.disabled = false));
			}

			disableInputFields() {
				this.disableableFields().forEach((field) => (field.disabled = true));
			}

			displayErrorMessage(title, body) {
				this.clearErrorMessage();
				this.errorMessageWrapper.hidden = false;
				if (typeof body === "object") {
					this.errorMessage.innerText = this.defaultErrorHeader;
					return Object.entries(body).forEach(([key, value]) => {
						const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
						const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
						const message = `${value.join(", ")}`;
						const errorMessageElement = this.querySelector(
							`#${errorMessageId}`
						);
						const errorTextElement =
							errorMessageElement?.querySelector(".error-message");
						if (!errorTextElement) return;

						if (this.errorMessageList) {
							this.errorMessageList.appendChild(
								this.createErrorListItem(fieldSelector, message)
							);
						}

						errorTextElement.innerText = `${message}.`;
						errorMessageElement.classList.remove("hidden");

						const inputElement = this[`${key}Input`];
						if (!inputElement) return;

						inputElement.setAttribute("aria-invalid", true);
						inputElement.setAttribute("aria-describedby", errorMessageId);
					});
				}

				this.errorMessage.innerText = body;
			}

			createErrorListItem(target, message) {
				const li = document.createElement("li");
				const a = document.createElement("a");
				a.setAttribute("href", target);
				a.innerText = message;
				li.appendChild(a);
				li.className = "error-message";
				return li;
			}

			clearErrorMessage() {
				this.errorMessageWrapper.hidden = true;

				if (this.errorMessageList) this.errorMessageList.innerHTML = "";

				this.querySelectorAll(".recipient-fields .form__message").forEach(
					(field) => {
						field.classList.add("hidden");
						const textField = field.querySelector(".error-message");
						if (textField) textField.innerText = "";
					}
				);
				[
					this.emailInput,
					this.messageInput,
					this.nameInput,
					this.sendonInput,
				].forEach((inputElement) => {
					inputElement.setAttribute("aria-invalid", false);
					inputElement.removeAttribute("aria-describedby");
				});
			}

			resetRecipientForm() {
				if (this.checkboxInput.checked) {
					this.checkboxInput.checked = false;
					this.clearInputFields();
					this.clearErrorMessage();
				}
			}
		}
	);
}
